import React, { useEffect, useState } from "react";
// import banner from "./mangehotel.jpg";
// import './menu.css'
import CateringIcons from "./CateringIcons";
import { Link } from "react-router-dom";

import CateringAboutmaamaas from "./CateringAboutmaamaas.js";
import CateringLeadershipCard from "./CateringLeadershipCard.js";
import CateringMissionVisionCards from "./CateringMissionVisionCards";
import CateringGalleryCards from "./CateringGalleryCards";
import axios from "axios";
import CateringCombos from "./CateringCombos";
import CateringSuperOffer from './CateringSuperOffer';

const CateringMenudata = ({ vendorIdFromProps }) => {
    const [showMore, setShowMore] = useState(false);
    const [showMoree, setShowMoree] = useState(false);

    const vendorId =
        vendorIdFromProps ||
        localStorage.getItem("vendorId") ||
        3;

    const [bannerData, setBannerData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 480);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 480);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        if (!vendorId) return;

        const source = axios.CancelToken.source();
        const token = localStorage.getItem("authToken");

        (async () => {
            try {
                setLoading(true);

                const { data } = await axios.get(
                    `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/banner/get/${vendorId}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                        cancelToken: source.token,
                    }
                );

                setBannerData({
                    ...data,
                    companyLogo: toImageSrc(data.companyLogo),
                    companyBanner: toImageSrc(data.companyBanner),
                });
                setError("");
            } catch (err) {
                if (!axios.isCancel(err)) {
                    console.error(err);
                    setError("Could not load banner details.");
                }
            } finally {
                setLoading(false);
            }
        })();

        return () => source.cancel();
    }, [vendorId]);

    const toImageSrc = (raw) => {
        if (!raw || raw.trim() === "/" || raw.trim() === "") return "/placeholder.svg";

        const clean = raw.trim();

        // If it's already a data URL or external URL, return as is
        if (clean.startsWith("data:image")) return clean;
        if (/^https?:\/\//i.test(clean)) return clean;

        // Check if it's base64 data (typically long string)
        if (clean.length > 100) {
            const mime = clean.startsWith("iVBORw0KGgo") ? "image/png" : "image/jpeg";
            return `data:${mime};base64,${clean}`;
        }

        // MinIO URL construction
        const minioBaseUrl = "http://10.10.20.9:9000";

        // If it's already a full MinIO path, use as is
        if (clean.startsWith("catering/") || clean.includes("/")) {
            return `${minioBaseUrl}/${clean}`;
        }

        // If it's just a filename, assume it's in catering bucket
        return `${minioBaseUrl}/catering/${clean}`;
    };

    const data = [
        {
            image: '/images/dish1.jpg',
            text: '17+ Clients',
            icon: '⭐',
        },
        {
            image: '/images/dish2.jpg',
            text: '7+ Experience',
            icon: '⚙️',
        },
        {
            image: '/images/dish3.jpg',
            text: '60+ Subscribers',
            icon: '👥',
        },
    ];
    if (!bannerData) return null;

    const {
        companyName,
        establishedYear,
        whatsappLink,
        instagramLink,
        facebookLink,
        twitterLink,
        companyLogo,
        companyBanner,
    } = bannerData;

    if (loading) return <p>Loading banner…</p>;
    if (error) return <p style={{ color: "crimson" }}>{error}</p>;
    if (!bannerData) return null;

    return (
        <div>
            <div style={{ height: "auto", overflowY: "none", scrollbarWidth: "none", marginTop: "92px" }} className="home-menu-scroll">
                <div className=" home-menu-data">

                    <div className=" align-items-center  topticdata" >

                        <div className="text-center">

                            <div
                                style={{
                                    position: "relative",
                                    display: "inline-block",
                                    marginTop: isMobile ? "0px" : "70px",
                                    marginBottom: "20px",
                                    zIndex: "-1111"
                                }}
                            >


                                {companyBanner && (
                                    <img
                                        src={companyBanner}
                                        alt={`${companyName} banner`}
                                        style={{
                                            height: 500,
                                            borderRadius: 10,
                                            objectFit: "cover",
                                            display: "block",
                                            marginTop: "10px"
                                        }}
                                        className="home-main-banner"
                                    />
                                )}
                                <div
                                    style={{
                                        position: "absolute",
                                        top: 24,
                                        left: "50%",
                                        transform: "translateX(-50%)",
                                        color: "#fff",
                                        textAlign: "center",
                                        textShadow: "0 1px 4px rgba(0,0,0,.6)",
                                    }}
                                >
                                    <h1
                                        style={{
                                            margin: 0,
                                            fontSize: 53,
                                            fontWeight: "bold",
                                            fontFamily: "SF Pro, sans-serif",
                                            background: "linear-gradient(90deg, red, white)",
                                            WebkitBackgroundClip: "text",
                                        }}
                                    >
                                        {companyName}
                                    </h1>

                                    <p
                                        style={{
                                            margin: 4,
                                            fontSize: 22,
                                            fontWeight: "bold",
                                            fontFamily: "SF Pro, sans-serif",
                                            color: "#fff",
                                        }}
                                    >
                                        Since {establishedYear}
                                    </p>

                                    <div
                                        style={{
                                            position: "absolute",
                                            top: 0,
                                            right: -320,
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "10px",
                                        }}
                                    >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="iconbuttongroup">
                        <div className="buttongroup">
                            <div className="timeboxy">
                                <p>Open: 9:30 AM</p>
                            </div>
                            <div className="timebox">
                                <p>Close: 10:30 PM</p>
                            </div>

                            <button
                                onClick={() => setShowMore(!showMore)}
                                className="greenbtn"
                            >
                                {showMore ? "Show Less" : "Know More"}
                            </button>

                            <button
                                onClick={() => setShowMoree(!showMoree)}
                                className="bluebtn"
                            >
                                {showMoree ? "Hide Gallery" : "View Gallery"}
                            </button>
                        </div>

                        <div className="icon">
                            <CateringIcons />
                        </div>
                    </div>

                    {showMore && (
                        <div>
                            <CateringAboutmaamaas />
                            <CateringLeadershipCard />
                            <CateringMissionVisionCards />
                        </div>
                    )}
                    {showMoree && (
                        <div>
                            <CateringGalleryCards />
                        </div>
                    )}
                    {/* <div style={{ marginTop: "20px" }}>
                        <CateringCombos />
                        <CateringSuperOffer />
                    </div> */}
                </div>
            </div>
        </div>
    );
};

export default CateringMenudata;






